//
//  getToday.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import dayjs from "dayjs";
export const getToday = () => dayjs();
